// テーブル見出し 文言
export const tableTitle = {
    interview: '面談先選定',
    message: '条件相談',
    proposal: '提案意向',
    question: '質問回答',
    status: '最終結果',
    title: '案件名／責任者',
    viewRequest: '詳細閲覧',
};
// 0件表示 文言
export const noDataText = '提案募集中の案件はありません';
// ローディング表示行数 初期値
export const initialSkeletonRowCount = 4;
